import { PortableText } from '@portabletext/react'
import {
  type ArbitraryTypedObject,
  type PortableTextBlock,
} from '@portabletext/types'

import Icon from '@components/icon'
import ColoredText from './blocks/colored-text'
import Figure from './blocks/figure'
import HorizontalRule from './blocks/horizontal-rule'
import InfoBox from './blocks/info-box'
import Link from './blocks/link'
import Quote from './blocks/quote'
import TypedText from './blocks/typed-text'
import VideoButton from './blocks/video-button'
import VideoEmbed from './blocks/video-embed'

type ComplexPortableTextBlock = PortableTextBlock | ArbitraryTypedObject

interface ComplexPortableTextProps {
  content: ComplexPortableTextBlock[]
  className?: string
}

const ComplexPortableText = ({
  content,
  className,
}: ComplexPortableTextProps) => {
  return (
    <div className={className}>
      <PortableText
        value={content}
        components={{
          block: {
            none: ({ children }) => <>{children}</>,
            normal: ({ children }) => <p>{children}</p>,
            small: ({ children }) => <p className="text-base">{children}</p>,
            preamble: ({ children }) => <p className="preamble">{children}</p>,
            h1hero: ({ children }) => (
              <h1 className="is-h1-hero">{children}</h1>
            ),
            h1: ({ children }) => <h1>{children}</h1>,
            h2: ({ children }) => <h2>{children}</h2>,
            h3: ({ children }) => <h3>{children}</h3>,
            h4: ({ children }) => <h4>{children}</h4>,
            h5: ({ children }) => <h5>{children}</h5>,
            h1mock: ({ children }) => <p className="is-h1">{children}</p>,
            h2mock: ({ children }) => <p className="is-h2">{children}</p>,
            h3mock: ({ children }) => <p className="is-h3">{children}</p>,
            h4mock: ({ children }) => <p className="is-h4">{children}</p>,
            h5mock: ({ children }) => <p className="is-h5">{children}</p>,
          },
          types: {
            figure: Figure,
            horizontalRule: HorizontalRule,
            infoBox: InfoBox,
            quote: Quote,
            videoButton: VideoButton,
            videoEmbed: VideoEmbed,
          },
          marks: {
            link: Link,
            textColor: ColoredText,
            textTyping: TypedText,
          },
          list: {
            bullet: ({ children }) => <ul className="bullet-ul">{children}</ul>,
            greenCorner: ({ children }) => <ul>{children}</ul>,
          },
          listItem: {
            bullet: ({ children }) => <li>{children}</li>,
            greenCorner: ({ children }) => (
              <li>
                <Icon
                  name="BulletCorner"
                  className="absolute top-1 left-0 h-[17px] text-green-electric"
                />
                {children}
              </li>
            ),
          },
        }}
      />
    </div>
  )
}

export default ComplexPortableText
